<flx-resources-grid
  [hasBackground]="false"
  [inputGridOptions]="gridOptions()"
  [tableDef]="workflowsTableCols"
  [uniqueKeys]="['id']"
  [emptyMsg]="'No workflows'"
  [emptyMsgDescription]="'Workflow runs started by this instance appear here.'"
  [rowClickEnabled]="true"
  (rowClick)="viewInstanceDetails($event)"
  (gridReady)="onGridReady($event)"
  emptyMsgIcon="ph ph-flow-arrow"
/>

<ng-template
  [flxShowModal]="showDetailsModal()"
  panelClass="flx-instance-workflows-panel"
>
  <flx-workflow-instance-details-modal
    [workflowInstanceId]="selectedWorkflowInstanceId()"
    [workflowName]="selectedWorkflowName()"
    (hideModal)="hideDetailsModal()"
  />
</ng-template>
